import { BFFApi, updateServiceBaseUrl } from '@clear-denver/tpc-bff-client'

export const fetchLocations = async () => {
  if (process.env.NEXT_PUBLIC_APP_ENV === 'prod') {
    updateServiceBaseUrl(
      'tpcBff',
      'https://tsaprecheckbyclear.tsa.dhs.gov/v1/tpc-enrollment-bff'
    )
  }
  const api = BFFApi.getGeneratedAPI()
  const activeLocations = await api.getLocations()
  return activeLocations
}
